import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

import { SMILES_LOGO_DATA_URI } from './smilesLogoData'

interface SmilesLogoProps {
    sx?: SxProps<Theme>
    width?: number
    height?: number
}

const SmilesLogo = ({ sx, width = 24, height = 24 }: SmilesLogoProps) => (
    <Box
        component="img"
        src={SMILES_LOGO_DATA_URI}
        alt="Smiles"
        sx={{ width, height, display: 'block', borderRadius: '5px', flexShrink: 0, ...sx }}
    />
)

export default SmilesLogo
